import { createFileRoute, redirect } from "@tanstack/react-router";

import { activeOrganization$ } from "~/stores/organizations";

export const Route = createFileRoute("/_app/settings/_organization")({
  beforeLoad: async () => {
    const orgId = activeOrganization$.id.get();
    if (!orgId) {
      throw redirect({ to: "/" });
    }
  },
});
